import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.8;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 900;
  margin-bottom: 20px;
  color: var(--color-black);
  text-align: center;
  letter-spacing: 1px;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin: 40px 0 20px 0;
  color: var(--color-black);
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: var(--color-black);
  margin-bottom: 20px;
  text-align: justify;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    text-align: left;
  }
`;

const Highlight = styled.span`
  font-weight: 700;
  color: var(--color-black);
`;

const MissionBox = styled.div`
  border: 2px solid var(--color-black);
  padding: 30px;
  margin: 30px 0;
  text-align: center;
`;

const MissionText = styled.p`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-black);
  margin: 0;
  font-style: italic;
`;

const ThankYouBox = styled.div`
  border-top: 2px solid var(--color-black);
  border-bottom: 2px solid var(--color-black);
  padding: 30px 0;
  margin: 40px 0;
  text-align: center;
`;

const ThankYouText = styled.p`
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--color-black);
  margin: 0;
`;

const AboutScreen: React.FC = () => {
  return (
    <Container>
      <Title>Accord: Your Style, In Harmony.</Title>
      
      <Paragraph>
        We believe a phone is more than just a communication tool; it's an extension of your personal style. Yet, we've noticed an invisible gap between the texture of our physical world (the phone case) and the expression on our digital screen (the wallpaper). This often leaves our overall style experience feeling incomplete.
      </Paragraph>
      
      <Paragraph>
        At <Highlight>Accord</Highlight>, we are dedicated to bridging that gap.
      </Paragraph>
      
      <MissionBox>
        <MissionText>
          Our mission is to seamlessly merge your digital world with your real-world style.
        </MissionText>
      </MissionBox>
      
      <Paragraph>
        Accord is an AI-driven aesthetic tool that deeply understands the color, texture, and design of your phone case, crafting a custom wallpaper that harmoniously resonates with it. We strive for more than just a visual match; we aim for a complete and seamless aesthetic experience that flows from the physical to the digital, from touch to sight.
      </Paragraph>
      
      <Paragraph>
        Every time you unlock your phone, it becomes a confirmation of your unique taste.
      </Paragraph>
      
      <Subtitle>Who We Are</Subtitle>
      
      <Paragraph>
        We are <Highlight>Acronyx Technologies</Highlight>, a startup team based in Sydney, Australia, composed of creators who are passionate about design, technology, and the aesthetics of everyday life. As an emerging company, we are full of energy and eager to bring more beauty and harmony into the daily lives of users worldwide through an innovative lens.
      </Paragraph>
      
      <ThankYouBox>
        <ThankYouText>
          Thank you for your interest in Accord. We invite you to join us on this journey of exploring personalized aesthetics, and to let your style be consistent, inside and out.
        </ThankYouText>
      </ThankYouBox>
    </Container>
  );
};

export default AboutScreen;
